import { render, staticRenderFns } from "./AppApprovals.vue?vue&type=template&id=0ff2ad36&scoped=true&"
import script from "./AppApprovals.vue?vue&type=script&lang=js&"
export * from "./AppApprovals.vue?vue&type=script&lang=js&"
import style0 from "./AppApprovals.vue?vue&type=style&index=0&id=0ff2ad36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff2ad36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDataTable,VForm,VIcon,VProgressCircular,VSimpleTable,VTextarea})
